import React, { Component } from 'react';
import './homework.scss';
import { ImageConstants, AccessRights, Constants } from '../../constants/constants';
import { getImageSource, getThemeImageSource } from '../../utility/image-source'
import HomeworkList from './homework-list/homework-list'
import NewHomework from './new-homework/new-homework'

import SessionCache from '../routes/session-cache';
import ClickerFlowPracticeListScreen from '../clicker-flow-practice-v3/clicker-flow-practice-list/clicker-flow-practice-list-v1'
import CommonUtils from '../../utility/common-utilities';
import TestList from '../tests-v3/test-list/test-list';
import ClickerAssessment from '../clicker-assessment/test-list/test-list'
class Homework extends Component {
    state = {
        showHomeworkList: false
    }

    selectedHomeworkType = "STANDARD_CLASSWORK"

    accessRights = SessionCache.getAllowedModule()
    userInfo = SessionCache.getUser()
    constructor(props) {
        super(props)
        console.log(window.location.pathname);
        console.log(this.userInfo)
        const paths = window.location.pathname.split("/")
        console.log(paths[paths.length - 1])
        console.log(this.props.location)
        if (paths[paths.length - 1] === "adaptiveclasswork") {
            this.selectedHomeworkType = "ADAPTIVE_CLASSWORK"
            this.state.showHomeworkList = true
            console.log('inside adaptive')
        } else if (this.props?.location?.state?.type != 'CLICKER_PRACTICE_STANDARD') {
            console.log('.........')
            this.selectedHomeworkType = "STANDARD_CLASSWORK"

            if (this.props?.location?.state?.showHomeworkList) {
                this.state.showHomeworkList = true
            } else {
                this.state.showHomeworkList = false
            }
        }
    }
    componentDidMount() {

        if (this.props?.location?.showList) {
            this.setState({
                showHomeworkList: true
            })
        }

        if (this.props?.location?.state?.showNewHomework) {

            console.log(this.props.location)

            this.setState({
                showHomeworkList: true
            })
        }

        if (this.props?.location?.state?.type === 'CLICKER_PRACTICE_STANDARD') {
            console.log('inside', this.props?.location?.state?.type)
            this.onSelectHomework('CLICKER_PRACTICE_STANDARD')
        }

    }

    componentDidUpdate(prevProps, prevState) {
        // update state 
        console.log(prevProps.location.pathname)
        console.log(this.props.location.pathname)
        if (prevProps.location.pathname !== this.props.location.pathname) {
            const paths = window.location.pathname.split("/")
            console.log(paths[paths.length - 1])
            if (paths[paths.length - 1] === "adaptiveclasswork") {
                this.selectedHomeworkType = "ADAPTIVE_CLASSWORK"
                this.state.showHomeworkList = true
            } else {
                this.selectedHomeworkType = "STANDARD_CLASSWORK"
                this.state.showHomeworkList = false
            }
            this.setState({
                showHomeworkList: false
            }, _ => {

                if (paths[paths.length - 1] === "adaptiveclasswork") {
                    this.setState({
                        showHomeworkList: true
                    })
                } else {
                    this.setState({
                        showHomeworkList: false
                    })
                }

            })
        }
    }


    onSelectHomework = (type) => {
        this.selectedHomeworkType = type

        if (type === 'CLICKER_PRACTICE_STANDARD') {
            this.setState({ showClickerHomeworkList: true })
        } else if (type === 'ASSESSMENT') {
            this.setState({ showAssessmentList: true })
        } else if (type === 'CLICKER_ASSESSMENT') {
            this.setState({ showClickerAssessment: true })
        } else {
            this.selectedHomeworkType = type
            this.setState({ showHomeworkList: true })
        }

    }

    handleGoBack = () => {
        this.setState({ showHomeworkList: false, showClickerHomeworkList: false, showAssessmentList: false, showClickerAssessment: false })
    }

    showNewHomework = () => {
        this.setState({ showNewHomework: true })
    }

    hideNewHomework = () => {
        this.setState({ showNewHomework: false })
    }

    render() {

        if (this.state.showNewHomework)
            return <NewHomework type={this.selectedHomeworkType} delegate={this} back={this.hideNewHomework} />

        if (this.state.showHomeworkList)
            return <HomeworkList type={this.selectedHomeworkType} delegate={this} back={this.handleGoBack} showBackButton={true} filter={this.props.filter} />

        if (this.state.showClickerHomeworkList)
            return <ClickerFlowPracticeListScreen type={this.selectedHomeworkType} delegate={this} back={this.handleGoBack} showBackButton={true} />

        if (this.state.showAssessmentList) {
            return <TestList back={this.handleGoBack} />
        }

        if (this.state.showClickerAssessment) {
            return <ClickerAssessment back={this.handleGoBack} />
        }

        return (
            <>
                {
                    // this.userInfo.subjectId === Constants.SCIENCE_SUBJECTID ?

                    //     <div className='homework'>
                    //         <span className='screen-title'>Schoolwork</span>

                    //         {
                    //             this.accessRights[AccessRights.STANDARD_HOMEWORK_VIEW] && CommonUtils.isOnline() && !Constants.ELECTRON_BUILD ?
                    //                 <div className='cw-plain-card cw-plain-card-wrapper mt-3 cursor-pointer' onClick={() => this.onSelectHomework('ASSESSMENT')}>

                    //                     <div className='row'>
                    //                         <div className='col-1 pr-0'>
                    //                             <div className='icon-wrapper'>
                    //                                 <img className='homework-icon' src={getImageSource(ImageConstants.DESKTOP_ICON)} />
                    //                             </div>
                    //                         </div>

                    //                         <div className='col-9 justify-center pl-0'>
                    //                             <div className='sub-title'>Assessment Using Computer Lab</div>
                    //                             <span className='pt-3'>Student attempts all the questions in one go followed by learning</span>
                    //                         </div>

                    //                         <div className='col-2 align-center'>
                    //                             <img className='right-arrow' src={getImageSource(ImageConstants.RIGHT_ARROW)} />
                    //                         </div>
                    //                     </div>
                    //                 </div> : ""
                    //         }

                    //         <img className='divider-image-width mt-4 mb-2' src={getThemeImageSource(ImageConstants.PRACTICE_QUESTION_DIVIDER, 1)} />

                    //         {this.accessRights[AccessRights.STANDARD_HOMEWORK_VIEW] && this.userInfo.schoolInfo.clickerExist ?
                    //             <div className='cw-plain-card cw-plain-card-wrapper mt-3 cursor-pointer' onClick={() => this.onSelectHomework('CLICKER_ASSESSMENT')}>


                    //                 <div className='row'>
                    //                     <div className='col-1 pr-0'>
                    //                         <div className='icon-wrapper'>
                    //                             <img className='clicker-icon' src={getImageSource(ImageConstants.CLICKER_ICON)} />
                    //                         </div>
                    //                     </div>

                    //                     <div className='col-9 justify-center pl-0'>
                    //                         <div className='sub-title'>Assessment Using Clicker</div>
                    //                         <span className='pt-3'>Student do questions & learning together for each ELO, one after other</span>
                    //                     </div>

                    //                     <div className='col-2 align-center'>

                    //                         <img className='right-arrow' src={getImageSource(ImageConstants.RIGHT_ARROW)} />
                    //                     </div>
                    //                 </div>
                    //             </div>
                    //             :
                    //             <div className='cw-plain-card cw-plain-card-wrapper-disabled mt-3'>

                    //                 <div className='row'>
                    //                     <div className='col-1 pr-0'>
                    //                         <div className='icon-wrapper'>
                    //                             <img className='clicker-icon' src={getImageSource(ImageConstants.CLICKER_ICON)} />
                    //                         </div>
                    //                     </div>

                    //                     <div className='col-9 justify-center pl-0'>
                    //                         <div className='sub-title'>Assessment Using Clicker</div>
                    //                         <span className='pt-3'>Student do questions & learning together for each ELO, one after other</span>
                    //                     </div>

                    //                     <div className='col-2 align-center'>

                    //                         <img className='right-arrow' src={getImageSource(ImageConstants.RIGHT_ARROW)} />
                    //                     </div>
                    //                 </div>
                    //             </div>
                    //         }

                    //     </div >


                    //     :
                    <div className='homework'>
                        <span className='screen-title'>Schoolwork</span>
                        {
                            this.accessRights[AccessRights.STANDARD_HOMEWORK_VIEW] && CommonUtils.isOnline() && !Constants.ELECTRON_BUILD ?
                                <div className='cw-plain-card cw-plain-card-wrapper mt-2 cursor-pointer' onClick={() => this.onSelectHomework('STANDARD_CLASSWORK')}>

                                    <div className='row'>
                                        <div className='col-1 pr-0'>
                                            <div className='icon-wrapper'>
                                                <img className='homework-icon' src={getImageSource(ImageConstants.DESKTOP_ICON)} />
                                            </div>
                                        </div>

                                        <div className='col-9 justify-center pl-0'>
                                            <div className='sub-title'>Practice Using Computer Lab</div>
                                            <span className='pt-3'>Student attempts all the questions in one go followed by learning</span>
                                        </div>

                                        <div className='col-2 align-center'>
                                            <img className='right-arrow' src={getImageSource(ImageConstants.RIGHT_ARROW)} />
                                        </div>
                                    </div>
                                </div> : ""
                        }
                        {
                            this.accessRights[AccessRights.STANDARD_HOMEWORK_VIEW] && CommonUtils.isOnline() && !Constants.ELECTRON_BUILD ?
                                <div className='cw-plain-card cw-plain-card-wrapper mt-3 cursor-pointer' onClick={() => this.onSelectHomework('ASSESSMENT')}>

                                    <div className='row'>
                                        <div className='col-1 pr-0'>
                                            <div className='icon-wrapper'>
                                                <img className='homework-icon' src={getImageSource(ImageConstants.DESKTOP_ICON)} />
                                            </div>
                                        </div>

                                        <div className='col-9 justify-center pl-0'>
                                            <div className='sub-title'>Assessment Using Computer Lab</div>
                                            <span className='pt-3'>Student attempts all the questions in one go followed by learning</span>
                                        </div>

                                        <div className='col-2 align-center'>
                                            <img className='right-arrow' src={getImageSource(ImageConstants.RIGHT_ARROW)} />
                                        </div>
                                    </div>
                                </div> : ""
                        }
                        {
                            this.accessRights[AccessRights.STANDARD_HOMEWORK_VIEW] && CommonUtils.isOnline() && !Constants.ELECTRON_BUILD ?
                                <div className='cw-plain-card cw-plain-card-wrapper mt-4 cursor-pointer' onClick={() => this.onSelectHomework('ADAPTIVE_CLASSWORK')}>

                                    <div className='row'>
                                        <div className='col-1 pr-0'>
                                            <div className='icon-wrapper'>
                                                <img className='homework-icon' src={getImageSource(ImageConstants.DESKTOP_ICON)} />
                                            </div>
                                        </div>

                                        <div className='col-9 justify-center pl-0'>
                                            <div className='sub-title'>Personalised Schoolwork Using Computer Lab</div>
                                            <span className='pt-3'>Student attempts all the questions in one go followed by learning</span>
                                        </div>

                                        <div className='col-2 align-center'>
                                            <img className='right-arrow' src={getImageSource(ImageConstants.RIGHT_ARROW)} />
                                        </div>
                                    </div>
                                </div> : ""
                        }
                        <img className='divider-image-width mt-4 mb-2' src={getThemeImageSource(ImageConstants.PRACTICE_QUESTION_DIVIDER, 1)} />
                        {this.accessRights[AccessRights.STANDARD_HOMEWORK_VIEW] && this.userInfo.schoolInfo.clickerExist ?
                            <div className='cw-plain-card cw-plain-card-wrapper mt-3 cursor-pointer' onClick={() => this.onSelectHomework('CLICKER_PRACTICE_STANDARD')}>


                                <div className='row'>
                                    <div className='col-1 pr-0'>
                                        <div className='icon-wrapper'>
                                            <img className='clicker-icon' src={getImageSource(ImageConstants.CLICKER_ICON)} />
                                        </div>
                                    </div>

                                    <div className='col-9 justify-center pl-0'>
                                        <div className='sub-title'>Classroom Practice</div>
                                        <span className='pt-3'>Student do questions & learning together for each ELO, one after other</span>
                                    </div>

                                    <div className='col-2 align-center'>

                                        <img className='right-arrow' src={getImageSource(ImageConstants.RIGHT_ARROW)} />
                                    </div>
                                </div>
                            </div>
                            :
                            <div className='cw-plain-card cw-plain-card-wrapper-disabled mt-3'>

                                <div className='row'>
                                    <div className='col-1 pr-0'>
                                        <div className='icon-wrapper'>
                                            <img className='clicker-icon' src={getImageSource(ImageConstants.CLICKER_ICON)} />
                                        </div>
                                    </div>

                                    <div className='col-9 justify-center pl-0'>
                                        <div className='sub-title'>Classroom Practice</div>
                                        <span className='pt-3'>Student do questions & learning together for each ELO, one after other</span>
                                    </div>

                                    <div className='col-2 align-center'>

                                        <img className='right-arrow' src={getImageSource(ImageConstants.RIGHT_ARROW)} />
                                    </div>
                                </div>
                            </div>
                        }
                        {this.accessRights[AccessRights.STANDARD_HOMEWORK_VIEW] && this.userInfo.schoolInfo.clickerExist ?
                            <div className='cw-plain-card cw-plain-card-wrapper mt-3 cursor-pointer' onClick={() => this.onSelectHomework('CLICKER_ASSESSMENT')}>


                                <div className='row'>
                                    <div className='col-1 pr-0'>
                                        <div className='icon-wrapper'>
                                            <img className='clicker-icon' src={getImageSource(ImageConstants.CLICKER_ICON)} />
                                        </div>
                                    </div>

                                    <div className='col-9 justify-center pl-0'>
                                        <div className='sub-title'>Classroom Assessment</div>
                                        <span className='pt-3'>Student do questions & learning together for each ELO, one after other</span>
                                    </div>

                                    <div className='col-2 align-center'>

                                        <img className='right-arrow' src={getImageSource(ImageConstants.RIGHT_ARROW)} />
                                    </div>
                                </div>
                            </div>
                            :
                            <div className='cw-plain-card cw-plain-card-wrapper-disabled mt-3'>

                                <div className='row'>
                                    <div className='col-1 pr-0'>
                                        <div className='icon-wrapper'>
                                            <img className='clicker-icon' src={getImageSource(ImageConstants.CLICKER_ICON)} />
                                        </div>
                                    </div>

                                    <div className='col-9 justify-center pl-0'>
                                        <div className='sub-title'>Classroom Assessment</div>
                                        <span className='pt-3'>Student do questions & learning together for each ELO, one after other</span>
                                    </div>

                                    <div className='col-2 align-center'>

                                        <img className='right-arrow' src={getImageSource(ImageConstants.RIGHT_ARROW)} />
                                    </div>
                                </div>
                            </div>
                        }

                    </div >
                }
            </>)

    }
}

export default Homework;